export const SEARCH_TOOLTIP_IDLE_TIMEOUT = 20_000;
export const IDLE_SCREEN = 60_000;
